import { useLocation } from "react-router-dom";

export default function useQuery(params) {
    const searchParams =  new URLSearchParams(useLocation().search);
    return params ? searchParams.get(params) : searchParams;
}